/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import PreOpCheckList from './pre-op-check-list';
import PreOpCheckListDetail from './pre-op-check-list-detail';
import PreOpCheckListUpdate from './pre-op-check-list-update';
import PreOpCheckListDeleteDialog from './pre-op-check-list-delete-dialog';

const PreOpCheckListRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<PreOpCheckList />} />
    <Route path="new" element={<PreOpCheckListUpdate />} />
    <Route path=":id">
      <Route index element={<PreOpCheckListDetail />} />
      <Route path="edit" element={<PreOpCheckListUpdate />} />
      <Route path="delete" element={<PreOpCheckListDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default PreOpCheckListRoutes;
